import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBacklogRoute: InvariantJiraRoute = {
	name: 'rapidboard-backlog',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
};
